<rappider-modal className="'json-editor-modal'"
                [visible]="visible"
                [title]="title"
                [width]="width"
                [okText]="'Save'"
                [cancelText]="'Cancel'"
                (okClick)="saveChanges()"
                (cancelClick)="closeModal()">

  <div *ngIf="editorReady">
    <div class="code-editor-wrapper">
      <rappider-monaco-code-editor [(ngModel)]="stringifiedData"
                                   [title]="title"
                                   [options]="CODEMIRROR_JSON_SETTINGS"
                                   (ngModelChange)="onDataChange($event)"></rappider-monaco-code-editor>
    </div>
  </div>
</rappider-modal>
